// import Approvals from "../exemption/views/Approvals.vue";
const ExemptionApprovalForm = () =>
  import("../exemption/views/ExemptionApprovalForm.vue");
const MyExemptions = () => import("../exemption/views/MyExemptions.vue");
const AllExemptions = () => import("../exemption/views/AllExemptions.vue");
const Settings = () => import("../exemption/views/Settings.vue");
const ApprovalSettings = () =>
  import("../exemption/views/ApprovalSettings.vue");
const ApproverForm = () => import("../exemption/views/ApproverForm.vue");
const EditApproverForm = () =>
  import("../exemption/views/EditApproverForm.vue");
const EditExemptionForm = () =>
  import("../exemption/views/EditExemptionForm.vue");

export default [
  // {
  //   path: "approvals",
  //   component: Approvals
  // },
  {
    path: "create",
    component: ExemptionApprovalForm,
  },
  {
    name: "edit-exemptions",
    path: "edit/:id",
    component: EditExemptionForm,
  },
  {
    path: "my-exemptions",
    component: MyExemptions,
  },
  {
    path: "all-exemptions",
    component: AllExemptions,
  },
  {
    path: "settings",
    component: Settings,
  },
  {
    path: "approval-settings",
    component: ApprovalSettings,
  },
  {
    path: "approval/create",
    component: ApproverForm,
  },
  {
    name: "edit-exemptionApproval",
    path: "approver-settings/edit/:id",
    component: EditApproverForm,
  },
];
